import { N as NcActionButton } from "./chunks/NcActionButton-rjMoymt-.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-hhh3GBSS.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import { N as NcActionCheckbox } from "./chunks/NcActionCheckbox-DSMKeccY.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-CQ_WEPqQ.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import { N as NcActionRadio } from "./chunks/NcActionRadio-yAm71xxU.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-BKZA1xVL.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import { N as NcActionTextEditable } from "./chunks/NcActionTextEditable-xWQGdOVl.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-BS7BiMG0.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-BvEa92PC.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-hDsiQMLr.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-NIMhmJHh.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import NcAppNavigationNew from "./Components/NcAppNavigationNew.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-D4fJeBl0.mjs";
import { N as NcAppNavigationSearch } from "./chunks/NcAppNavigationSearch-B9OkdsuE.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-BV34ogWP.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-BwsIc_QT.mjs";
import NcAppSettingsSection from "./Components/NcAppSettingsSection.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-BJgPYOcZ.mjs";
import { N as NcAppSidebarHeader } from "./chunks/NcAppSidebarHeader-G2VD8Nfl.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-CgF-MFtU.mjs";
import { u } from "./chunks/NcAvatar-CgF-MFtU.mjs";
import { N as NcBlurHash } from "./chunks/NcBlurHash-do2wxY-0.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-DJpYjXCe.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-B722pBOd.mjs";
import NcButton from "./Components/NcButton.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-ip_mRd2T.mjs";
import { N as NcCollectionList } from "./chunks/NcCollectionList-Khg3X3Zq.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-MXMbRaLk.mjs";
import { N as NcContent } from "./chunks/NcContent-BbmqoSY7.mjs";
import { N as NcCounterBubble } from "./chunks/NcCounterBubble-CDfRYl8B.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-D0cFVt4i.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem-D33MR-DH.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-kanSdMgW.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-C1b3UtA7.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-Di9tU3e_.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-DJHvkF--.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import NcHeaderButton from "./Components/NcHeaderButton.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-Dq_Avv2T.mjs";
import { N as NcHighlight } from "./chunks/index-Bz6q9mZw.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-Cb-cPj1R.mjs";
import { N as NcInputField } from "./chunks/NcInputField-BNSfmQqu.mjs";
import { N as NcListItem } from "./chunks/NcListItem-CnxZixD_.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-CTfYEjBB.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-DSdrAkZy.mjs";
import { N as NcPopover } from "./chunks/NcPopover-CAJVK-MR.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-CI_nOrPg.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-DyvwxDjI.mjs";
import { N as NcMentionBubble } from "./chunks/index-B8gPNa8c.mjs";
import { r } from "./chunks/index-B8gPNa8c.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-cpptFUeI.mjs";
import { N as NcRichText } from "./chunks/NcRichText-CmuVmSzl.mjs";
import { N, h, d, i, b, r as r2, c, a } from "./chunks/index-56SXuvlv.mjs";
import "@vueuse/core";
import "vue";
import "vue-router";
import { a as a2, g, b as b2, c as c2, d as d2, s } from "./chunks/referencePickerModal-CtMUY45l.mjs";
import "unist-util-visit";
import "unist-builder";
import "@nextcloud/router";
import "@nextcloud/axios";
import "@nextcloud/sharing/public";
import "@nextcloud/auth";
import { N as NcSelect } from "./chunks/NcSelect-BUOuXJUQ.mjs";
import { N as NcTextField } from "./chunks/NcTextField-Do6wBDGH.mjs";
import "@nextcloud/event-bus";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-U7AIamCl.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags-hP98xYkg.mjs";
import { N as NcSelectUsers } from "./chunks/NcSelectUsers-DaHVPRPE.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-BKoaCiQU.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-fe_YIg-L.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-SuQNKdqU.mjs";
import { N as NcTextArea } from "./chunks/NcTextArea-BFLuhsEv.mjs";
import { N as NcThemeProvider } from "./chunks/NcThemeProvider-25ResoIv.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-bIwFQlmV.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-BmPOx3MW.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-DQr5EGWZ.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { useFormatDateTime, useFormatRelativeTime, useFormatTime } from "./Composables/useFormatDateTime.mjs";
import { useHotKey } from "./Composables/useHotKey.mjs";
import { useIsDarkTheme, useIsDarkThemeElement } from "./Composables/useIsDarkTheme.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { getEnabledContactsMenuActions, registerContactsMenuAction } from "./Functions/contactsMenu.mjs";
import { spawnDialog } from "./Functions/dialog.mjs";
import { E, a as a3, e, g as g2, s as s2 } from "./chunks/emoji-BY_D0V5K.mjs";
import { checkIfDarkTheme, isDarkTheme } from "./Functions/isDarkTheme.mjs";
import { preloadImage } from "./Functions/preloadImage.mjs";
import { usernameToColor } from "./Functions/usernameToColor.mjs";
import directive from "./Directives/Focus.mjs";
import { directive as directive$1 } from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a2 as anyLinkProviderId,
  checkIfDarkTheme,
  default2 as clickOutsideOptions,
  a3 as emojiAddRecent,
  e as emojiSearch,
  g2 as getCurrentSkinTone,
  getEnabledContactsMenuActions,
  g as getLinkWithPicker,
  b2 as getProvider,
  c2 as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  d as isCustomPickerElementRegistered,
  isDarkTheme,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i as isWidgetRegistered,
  preloadImage,
  registerContactsMenuAction,
  b as registerCustomPickerElement,
  r2 as registerWidget,
  c as renderCustomPickerElement,
  a as renderWidget,
  r as richEditor,
  d2 as searchProvider,
  s2 as setCurrentSkinTone,
  s as sortProviders,
  spawnDialog,
  useFormatDateTime,
  useFormatRelativeTime,
  useFormatTime,
  useHotKey,
  useIsDarkTheme,
  useIsDarkThemeElement,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  usernameToColor
};
//# sourceMappingURL=index.mjs.map
